module.exports = __webpack_public_path__ + "img/continue-button.cf7a578f.png";